import gqlClient from "../../dependencies/gqlClient";
import { readRestaurantFragment } from "../fragments/readRestaurantFragment";
import RestaurantDetailsQuery, {
  type QueryVariables,
} from "../queries/restaurantDetails";

export type GetRestaurantDetailsParams = {
  variables: QueryVariables;
  abortSignal?: AbortSignal;
};

export default async function getRestaurantDetails(
  variables: GetRestaurantDetailsParams["variables"],
  abortSignal: GetRestaurantDetailsParams["abortSignal"],
) {
  const { Restaurant } = await gqlClient({
    query: RestaurantDetailsQuery,
    variables,
    abortSignal,
  });

  const restaurant = readRestaurantFragment(Restaurant);

  if (!restaurant) {
    throw new Error(`Restaurant #${variables.id} not found`);
  }

  return restaurant;
}

export type RestaurantDetails = NonNullable<
  Awaited<ReturnType<typeof getRestaurantDetails>>
>;
